import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import useWindowSize from "../../../../../common/hooks/useWindowSize";
import { LeafDonutWithIcon } from "../../../../../common/leaf/LeafDonutWithIcon/LeafDonutWithIcon";
import breakpoints from "../../../../../common/scss/breakpoints.module.scss";
import defaultAwardContent from "../../../../../content/awardLabels";
import "./KpiTrackers.scss";

export interface KpiTrackerItem {
  label: ReactNode;
  percentage?: number;
  achievedSegments?: number;
  totalSegments?: number;
  isMet?: boolean;
  variant?: "progress" | "legs";
}

interface Props {
  items: KpiTrackerItem[];
}

export const KpiTrackers = ({ items }: Props) => {
  const { width } = useWindowSize();
  const { t } = useTranslation(["awardLabels"]);
  const noDataLabel = t(
    "awardLabels.no-data-available",
    defaultAwardContent.awardLabels["no-data-available"] as string,
  );
  const isMobile = Number(width) <= Number(breakpoints["tabletSmall"]);
  const donutSize = isMobile ? "sm" : "md";

  return (
    <div className="kpi-trackers">
      {items.map((item, i) => (
        <div key={i} className="kpi-trackers__row">
          <LeafDonutWithIcon
            size={donutSize}
            isMet={item.isMet ?? false}
            variant={item.variant ?? "progress"}
            percentage={item.percentage ?? 0}
            achievedSegments={item.achievedSegments ?? 0}
            totalSegments={item.totalSegments ?? 0}
          />
          <span
            className="kpi-trackers__label"
            {...(item.label === "--" ? { role: "text", "aria-label": noDataLabel } : {})}
          >
            {item.label === "--" ? <span aria-hidden="true">{item.label}</span> : item.label}
          </span>
        </div>
      ))}
    </div>
  );
};
